<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">
        Sales Order By Campaign
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="p-2">Campaign</span>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="campaign_info"
              placeholder="Enter campaign ..."
              @click.native="lkuSalesCamapignShow=true"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesCamapignShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 mr-2">Trx. Date</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl1" type="date" :state="!$v.model.tgl1.$error"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">-</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl2.$error"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="2">
          <b-button class="btn btn-success" @click="getData()">
            <i class="fa fa-play"></i> Process
          </b-button>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="tblLcy.items"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template
            v-slot:cell(startdate_campaign)="data"
          >{{ data.item.startdate_campaign | moment("D-MMM-YY") }}</template>
          <template
            v-slot:cell(enddate_campaign)="data"
          >{{ data.item.enddate_campaign | moment("D-MMM-YY") }}</template>
           <template v-slot:cell(numOfCust)="data">{{ data.item.numOfCust | numFormat }}</template>
           <template v-slot:cell(numOfTrx)="data">{{ data.item.numOfTrx | numFormat }}</template>
           <template v-slot:cell(matauang)="data">{{ uanguser }}</template>
          <template v-slot:cell(sumttlnetto)="data">{{ data.item.sumttlnetto | numFormat }}</template>
        </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>Total Omset : {{uanguser}} {{tblLcy.omsettotal | numFormat}}</div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="6" style="text-align:center">
                    <div>
                      Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                      to
                      <span
                        v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                      >{{tblLcy.total}}</span>
                      <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                      of {{tblLcy.total}} entries,
                      <span
                        class="ml-3 mr-1"
                      >limit per page :</span>
                    <input type="number" style="width:80px;" v-model="tblLcy.limit" v-b-tooltip.hover :title="`${tblLcy.limit} records`" />
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <b-pagination
                      align="right"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal
      v-model="lkuSalesCamapignShow"
      size="lg"
      :hide-footer="true"
      title="List of Sales Campaign"
      :centered="true"
    >
      <lku-salescampaign @click="onSelectsalescamapign"></lku-salescampaign>
    </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>


<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

import salesreport from "../../apis/salesReport";
import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalescampaign from "../lookup/lkuSalesCampaign";

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tgl1: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      lkuSalesCamapignShow: false,
      reportUrl: null,
      model: { 
        tgl1: moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').startOf('Year').format('YYYY-MM-DD'), 
        tgl2: moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').endOf('Year').format('YYYY-MM-DD'), 
        CampaignKey: null },
      filterShow: "Show",
      uanguser: this.$store.state.user.matauang,
      tblLcy: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "startdate_campaign",
            label: "Start Date",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "enddate_campaign",
            label: "End Date",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "campaign",
            label: "Description",
            sortable: true
          },
          {
            key: "numOfCust",
            label: "Total Customer",
            sortable: true
          },
          {
            key: "numOfTrx",
            label: "Total Trx",
            sortable: true
          },
          {
            key: "matauang",
            label: "$,¥",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "sumttlnetto",
            label: "Total Sales",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ]
      },
      filter: null,
      filterOn: [],
      cust_info: null,
      campaign_info: null
    };
  },
  components: { Loading, lkuKoranCust, lkuSalescampaign },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    }
  },
  // watch: {
  //   account: function(newval) {
  //     const obj = this.accounts.find(d => d.value === newval);
  //     this.model.namaacc = obj.text || "";
  //     this.model.kodeacc = obj.saleCrCode;
  //   }
  // },
  // created: function(){
  //   console.log('model :',this.model);
  // },
  methods: {
    onSelectsalescamapign(_selected) {
      this.campaign_info = `${_selected.uraian}`;
      // this.model.CampaignNo = _selected.campaignKey;
      this.model.CampaignKey = _selected.campaignKey;
      this.lkuSalesCamapignShow = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    getData: async function(ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        this.model.sortDir = this.model.sortDesc ? "desc" : "asc";
        const result = await salesreport.salesOrderByCampaign(this.model);
        this.tblLcy.items=result;
        this.tblLcy.total=result.length;
        this.tblLcy.omsettotal = result.reduce((a, b) => a + b.sumttlnetto, 0);
        this.isLoading = false;
      }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          await salesreport.salesOrderByCampaignExport2Excell(
            this.model
          );
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
